module.exports = __webpack_public_path__ + "static/media/ELS100PG01.3ee0959f.png";